import CTAUpsolveCommunity from "./CTAUpsolveCommunity";
import CTAFacebookGroup from "./CTAFacebookGroup";
import CTAFamousDebtors from "./CTAFamousDebtors";
import CTATestimonial from "./CTATestimonial";
import CTANewsletterSignup from "./CTANewsletterSignup";
import CTAWebinar from "./CTAWebinar";
import TestimonialsPreview from "../ProofBuilders/TestimonialsPreview";

// Offload shuffle to gatsby-node
export default function getInlineCTAComponents() {
  return {
    CTAUpsolveCommunity: CTAUpsolveCommunity,
    CTAFacebookGroup: CTAFacebookGroup,
    CTAFamousDebtors: CTAFamousDebtors,
    CTATestimonial: CTATestimonial,
    CTANewsletterSignup: CTANewsletterSignup,
    CTAWebinar: CTAWebinar,
  };
}
